import { Title as MantineTitle, useMantineTheme } from '@mantine/core'

import { TITLE_VARIANT_DEFAULT } from '@/components/Title/Title.constants'
import type { TitleProps } from '@/components/Title/Title.types'

export function Title({ variant, ...props }: TitleProps) {
  const theme = useMantineTheme()

  const variantConfig = TITLE_VARIANT_DEFAULT[variant]

  return (
    <MantineTitle c={theme.other.colors.black} {...variantConfig} {...props} />
  )
}
